import React from "react";
import Language from 'services/Language.js';
import Status from "../../../CryptoHistoryChecks/component/CryptoHistoryChecksItem/Status";
import CurrencyInfo from "../../../../../component/common/CurrencyInfo";
import PropTypes from "prop-types";
class WalletDesc extends React.Component {
    constructor(props) {
        super(props);
        this.state = { isCloseOn: false };

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        /*this.setState(prevState => ({
            isCloseOn: !prevState.isCloseOn
        }));*/

        if (typeof this.props.reset === 'function') {
            this.props.reset();
        }
    }

    render() {
        return (
            <div className={`wallet-desc ${this.state.isCloseOn ? 'wallet-desc--close' : ''}`}>
                <button className="wallet-desc__close" type="button" onClick={this.handleClick}>
                    <svg className="icon icon--close" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" />
                    </svg>
                </button>
                <div className="wallet-desc__header">
                    <div className="wallet-desc__header-title">
                        {Language.getLabel('L_CRYPTO_WALLETDESC_TITLE_1')}
                    </div>

                    <div className="wallet-desc__header-address">
                        {Language.getLabel('L_CRYPTO_WALLETDESC_TITLE_2')}
                    </div>

                    <div className="wallet-desc__header-status">
                        {Language.getLabel('L_CRYPTO_WALLETDESC_TITLE_3')}
                    </div>
                </div>

                <div className="wallet-desc__body">
                    <div className="wallet-desc__body-title">
                        <div className="wallet-desc__body-title-mob">
                            {Language.getLabel('L_CRYPTO_WALLETDESC_TITLE_1')}
                        </div>
                        <CurrencyInfo currency={this.props.currency} />
                    </div>

                    <div className="wallet-desc__body-address">
                        <div className="wallet-desc__body-title-mob">
                            {Language.getLabel('L_CRYPTO_WALLETDESC_TITLE_2')}
                        </div>
                        {this.props.address}
                    </div>

                    <div className="wallet-desc__body-status">
                        <div className="wallet-desc__body-title-mob">
                            {Language.getLabel('L_CRYPTO_WALLETDESC_TITLE_2')}
                        </div>
                        <Status status={this.props.status} />
                    </div>
                </div>
            </div>
        )
    }

    static propTypes = {
        onChange: PropTypes.func,
    };
}

export default WalletDesc